import validatePaidCampaign from '@helpers/validatePaidCampaign';
import axios from 'axios';
import has from 'lodash/has';
import React, { useEffect, useState } from 'react';
import BlogListComponent from '@/components/Blog/BlogList/BlogListComponent';
import FooterComponent from '@/components/Footer/FooterComponent';
import Header from '@/components/Header/Header';
import SEOHead from '@/components/SEOHead/SEOHead';
import { WordPressAPI } from '../config';
import { blogLeadValues as leadValues } from '../data/leadValues';
import dynamic from 'next/dynamic';

const FooterNewsModal = dynamic(import('@/components/FooterNewsModal'));

const GET_POST_URL = `${process.env.NEXT_PUBLIC_BLOG}/wp-json/wp/v2/posts`;
const GET_CATEGORIES_URL = `${process.env.NEXT_PUBLIC_BLOG}/wp-json/wp/v2/categories`;
const DELAY = 1500;

const Blog = (props) => {
  
  const [blogProps, setBlogProps] = useState(false);
  const acf = props.acf;
  const paid_campaign = validatePaidCampaign(acf.paid_campaign);
  const {
    phone_number_setup,
  } = acf;

  useEffect(() => {
    loadBlog()

  }, [props.query]);

  const loadBlog = async formData => {
    const currentPage = 1;
    let params = {
      _embed: true,
      page: currentPage,
      per_page: 10,
      hide_news: 1

    };
    const hasSearchKey = has(props.query, 's');
    if (hasSearchKey) {
      params = {
        ...params,
        search: props.query.s,
      };
    }


    const cats = await axios.get(GET_CATEGORIES_URL);
    const response = await axios
      .get(GET_POST_URL, { params })
      .then(({ data, headers }) => ({
        data,
        headers,
      }))
      .catch(error => {
        res.redirect('/blog');
      });

    const blogData = {
      categories: cats.data,
      posts: response.data,
      totalPost: response.headers['x-wp-total'],
      totalPage: response.headers['x-wp-totalpages'],
      ...props
    }
    setBlogProps(blogData)
  };


  return (
    <div>
      <SEOHead>
        <title>{acf.page_title_tag}</title>
        <meta name="description" content={acf.meta_description} />
        <script
          type="text/javascript"
          src="//app-ab33.marketo.com/js/forms2/js/forms2.min.js"
        />
      </SEOHead>
      <Header
        PaidCampaign={paid_campaign}
        phone_number={phone_number_setup}
        leadValues={leadValues}
      />
      {blogProps ? <BlogListComponent {...blogProps} /> : ''}
      {/* Email Newsletter */}
      <FooterNewsModal />
      <FooterComponent phone_number={phone_number_setup} />
    </div>
  );
}

Blog.getInitialProps = async ({ req, res, query }) => {
  const hasSearchKey = has(query, 's');
  const currentPage = 1;

  let params = {
    _embed: true,
    page: currentPage,
    per_page: 10,
  };

  if (hasSearchKey) {
    params = {
      ...params,
      search: query.s,
    };
  }

  const { data } = await axios.get(`${WordPressAPI.proxiedPages}/13668`);

  return {
    currentPage,
    params,
    acf: data.acf,
  };
};

export default Blog;
